import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Btn, Input } from "@/components/admin/ui";
import { useAuth, fmtErr } from "@/context/AuthProvider";

export const AdminLogin = () => {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user && user.role === "admin") nav("/admin"); }, [user, nav]);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await login(email, password); nav("/admin"); }
    catch (e) { setErr(fmtErr(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); }
  };
  return (
    <div className="admin-shell min-h-screen flex items-center justify-center p-6" style={{ background: "linear-gradient(180deg,#040A0F,#0A2438)" }}>
      <Card className="p-10 w-full max-w-md">
        <div className="font-serif text-3xl mb-1" style={{ background: "linear-gradient(135deg,#F4A93A,#FFD166,#D97B37)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Enchanted</div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#FFD166] mb-6">Gear Rentals · Admin</div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs text-[#B9C8D5] uppercase tracking-[0.2em]">Email</label>
            <Input type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div>
            <label className="text-xs text-[#B9C8D5] uppercase tracking-[0.2em]">Password</label>
            <Input type="password" required value={password} onChange={e => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          {err && <div className="text-sm text-red-400" data-testid="admin-login-error">{err}</div>}
          <Btn type="submit" disabled={busy} className="w-full justify-center" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign In"}
          </Btn>
        </form>
      </Card>
    </div>
  );
};
